/* Rotating announcement messages. Cross-fades between .cds-ab__message elements
   on an interval. No-op with 0 or 1 message, or when auto-rotate is off. */
class CordingsAnnouncement extends HTMLElement {
  connectedCallback() {
    this.messages = Array.from(this.querySelectorAll('.cds-ab__message'));
    if (this.messages.length <= 1 || this.dataset.autorotate === 'false') return;

    const interval = (parseInt(this.dataset.interval, 10) || 5) * 1000;
    let i = 0;
    this.timer = setInterval(() => {
      this.messages[i].classList.remove('is-active');
      i = (i + 1) % this.messages.length;
      this.messages[i].classList.add('is-active');
    }, interval);
  }

  disconnectedCallback() {
    if (this.timer) clearInterval(this.timer);
  }
}
customElements.define('cordings-announcement', CordingsAnnouncement);
